var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSamsungFavourite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7C3 4.79086 4.79086 3 7 3H17C19.2091 3 21 4.79086 21 7V17C21 19.2091 19.2091 21 17 21H7C4.79086 21 3 19.2091 3 17V7Z",
    stroke: "#000000",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5715 7.71185C11.7659 7.38894 12.234 7.38894 12.4284 7.71185L13.5365 9.55324C13.6063 9.66925 13.7202 9.75199 13.8521 9.78253L15.9458 10.2674C16.313 10.3525 16.4577 10.7977 16.2106 11.0823L14.8018 12.7053C14.713 12.8075 14.6695 12.9414 14.6812 13.0763L14.867 15.2174C14.8996 15.5928 14.5209 15.868 14.1739 15.721L12.195 14.8826C12.0703 14.8298 11.9296 14.8298 11.8049 14.8826L9.82603 15.721C9.47901 15.868 9.10027 15.5928 9.13286 15.2174L9.31868 13.0763C9.33038 12.9414 9.28689 12.8075 9.19813 12.7053L7.7893 11.0823C7.54225 10.7977 7.68691 10.3525 8.05407 10.2674L10.1478 9.78253C10.2797 9.75199 10.3936 9.66925 10.4634 9.55324L11.5715 7.71185Z",
    stroke: "#000000",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamsungFavourite);
export default __webpack_public_path__ + "static/media/samsung_favourite.c5ca5b91b4143c826369606c6cc6563b.svg";
export { ForwardRef as ReactComponent };